import React from "react";

const CardCredit = ({ useCount, price }) => {
  return (
    <div className="px-3 pb-3 flex items-end justify-between">
      <p className="text-sm text-333">{useCount ? useCount : "0"} 회 사용</p>
      {Number(price) === 0 ? (
        <p className="text-ss text-333">
          <span className="font-bold text-base text-black">Free</span>
        </p>
      ) : (
        <p className="text-ss text-333">
          <span className="font-bold text-sm text-primary">{price}</span> Credit
        </p>
      )}
    </div>
  );
};

export default CardCredit;
